import type { HelpFile } from '../../types/help'
import { JobBreadcrumbsTestIds } from '../../../testids/JobBreadcrumbsTestIds'

export const jobBreadcrumbsHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobBreadcrumbsTestIds.jobBreadcrumbs]:
      'Breadcrumb trail through the job hierarchy — parent job, child executions, and the current step.',
  },
}
